import { classNames } from "../../../helpers/cssClassHelper"
import "./Row.scss"
import React, { ReactNode } from 'react'

interface RowProps {
    children: ReactNode
    grow?: number
    className?: string,
    alignItems?: 'center' | 'stretch' | 'flex-start' | 'flex-end',
    justifyContent?: 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around'
    gap?: "0.5" | "0"
}

interface RowEndProps {
    children: ReactNode
    alignSelf?: 'flex-start' | 'flex-end' | 'center' | 'stretch'
    className?: string
}


interface RowColProps {
    children: ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

interface RowCompound extends React.FC<RowProps> {
    End: React.FC<RowEndProps>;
    Col: React.FC<RowColProps>;
}

export const Row: RowCompound = (props: RowProps) => {
    const className = classNames('row', props.className)
    const styles = {
        '--grow': props.grow,
        alignItems: props.alignItems ?? 'stretch',
        justifyContent: props.justifyContent ?? 'flex-start',
        gap: !!props.gap ? `${props.gap}rem` : "1rem"
    } as React.CSSProperties

    return (
        <div
            style={styles}
            className={className}>
            {props.children}
        </div>
    )
}


Row.End = (props: RowEndProps) => {
    return <div
        className={`row-end ${props.className}`}
        style={{ alignSelf: props.alignSelf ?? 'auto', gap: "0.5rem" }}>
            {props.children}
        </div>
}

Row.Col = ({ children, className, style }) => (
    <div
        className={className ? `row-col ${className}` : 'row-col'}
        style={{ flex: 1, minWidth: 0, ...style }}
    >
        {children}
    </div>
);
